module.exports = __webpack_public_path__ + "img/title2.ff20dc1d.png";